<template>
  <item-layout>
    <div
      slot="title"
      class="item-tit-box"
    >
      <template v-if="isSystem">
        <i
          v-if="!isCofigFormEdit"
          class="icon iconfont iconicon-test72"
        />
        <span
          v-if="!isCofigFormEdit"
          class="item-tit"
        >{{ dataInfo.fieldname }}</span>
        <template>
          <add-layout-form
            type="edit"
            :data-info="dataInfo"
            @addEdit="addEdit"
          />
          <a
            v-if="!isCofigFormEdit"
            href="javascript:;"
            @click="delConfigForm"
          >{{ $t('message["962"]') }}</a>
        </template>
      </template>
      <template v-else>
        <i
          class="icon iconfont iconicon-test72"
        />
        <span class="item-tit">{{ dataInfo.fieldname }}</span>
        <span>
          <a-checkbox
            disabled
            :checked="true"
          >
            {{ $t('message["25"]') }}
          </a-checkbox>
        </span>
      </template>
    </div>
    <div slot="collect-item-con">
      <draggable
        v-if="child.length"
        v-model="items"
      >
        <child-item
          v-for="(item, index) in items"
          :key="item.id || item._id"
          :item-data="item"
          :parent-index="dataIndex"
          :index="index"
          @del="remove"
        />
      </draggable>
      <a-button
        class="add-collect-item-btn"
        @click="add"
      >
        <i
          class="icon iconfont iconicon-test10"
        />

        {{ $t('message["1354"]') }}
      </a-button>
    </div>
  </item-layout>
</template>
<script>
import ChildItem from './ChildItem'
import ItemLayout from './ItemLayout'
import AddLayoutForm from '../AddLayoutForm'
import { mapMutations, mapState } from 'vuex'

export default {
  components: {
    ItemLayout,
    ChildItem,
    AddLayoutForm
  },
  props: {
    dataInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    dataIndex: {
      type: Number,
      default: 0
    },
    form: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isCofigFormEdit: false
    }
  },
  // mounted () {},
  computed: {
    ...mapState('config/referrer', ['datas']),
    items: {
      set (value) {
        this.dataInfo.child = value
      },
      get () {
        return this.child
      }
    },
    child () {
      return this.dataInfo.child
    },
    isSystem () {
      return (this.dataInfo.enabledelete && this.dataInfo.ischangename)
    }
  },
  methods: {
    ...mapMutations('config/referrer', []),
    add () {
      this.dataInfo.child.push({
        fieldname: '',
        fieldtype: 'text',
        enabledelete: 1,
        isneeded: 0,
        isenable: 1,
        ischangeenable: 1,
        ischangename: 1,
        ischangeneeded: 1,
        ischangetype: 1,
        options: [],
        _id: (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime()
      })
    },
    remove (k) {
      this.dataInfo.child.splice(k, 1)
    },
    addEdit () {
      this.isCofigFormEdit = !this.isCofigFormEdit
    },
    delConfigForm () {
      this.datas.splice(this.dataIndex, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
.item-tit-box::v-deep {
  .iconicon-test72 {
    font-size: 22px;
    cursor: move;
    color: #ccc;
    margin-right: 10px;
  }
  .item-tit{
    font-size: 18px;
    font-weight: 600;
    margin-right: 16px;
  }
  a {
    color: #5077aa;
  }
  .deal-info-tip {
    color: #b3b3b3;
  }
}
.add-collect-item-btn {
  margin:0 0 48px 38px;
  .iconicon-test10 {
    color: #ccc;
    font-size: 16px;
    margin-right: 6px;
  }
}
</style>
